import { ArrowLeft } from 'lucide-react';
import PortalHeader from './PortalHeader';

const Layout = ({
  children,
  step,
  totalSteps,
  showHome = true,
  showHelp = true,
  onBack,
  backLabel = 'Back',
}) => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <PortalHeader showHelp={showHelp} showHome={showHome} />
      <main className="mx-auto max-w-2xl px-0 py-5 sm:px-4 sm:py-8">
        <div>
          {onBack ? (
            <div className="mb-3 px-4 sm:px-0">
              <button
                type="button"
                onClick={onBack}
                aria-label={backLabel}
                className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-600 focus-visible:ring-offset-2"
              >
                <ArrowLeft className="h-4 w-4" aria-hidden="true" />
                <span>{backLabel}</span>
              </button>
            </div>
          ) : step && totalSteps ? (
            <div className="mb-3 flex items-center gap-1.5 px-4 sm:px-0" aria-label={`Step ${step} of ${totalSteps}`}>
              {Array.from({ length: totalSteps }, (_, i) => (
                <div
                  key={i}
                  className={`h-1.5 flex-1 rounded-full transition-colors ${
                    i < step ? 'bg-cyan-700' : 'bg-slate-200'
                  }`}
                />
              ))}
            </div>
          ) : null}
          <div className="border-y border-slate-200 bg-white px-4 py-5 sm:border sm:px-6 sm:py-6">
            {children}
          </div>
          <p className="border-b border-slate-100 bg-white px-4 py-3 text-center text-[10px] text-slate-400 sm:border-x">
            A service by Kivi3 Technologies Ltd · Licensed by Dubai International Financial Centre.
          </p>
        </div>
      </main>
    </div>
  );
};

export default Layout;
